import styled from "@emotion/styled"

export const TableSectionWrapper = styled.div`
	background-color: #fff;
	border-radius: 16px;
	padding: 16px;
	p {
		margin: 0;
	}
	.Header {
		margin-bottom: 16px;
		p {
			color: #435363;
			font-weight: 400;
			font-size: 24px;
			line-height: 28.8px;
		}
	}
`
